import { render } from "./np-bank.vue?vue&type=template&id=074b7ad8"
import script from "./np-bank.vue?vue&type=script&lang=js"
export * from "./np-bank.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__